// @TODO (russell): There are probably a lot more colors between the new
// LOHP-related files that need to be here, but this is a start.
export const MarketingColors = {
    highlightTeal: "#BFE6DD",
    lightTan: "#F5F5F5",
    lightGray: "#EEEEEE",
    paleGreen: "#BDE9DB",
    darkGray: "#2D444E",
} as const;
